import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
// import IntroPage from './components/IntroPage';
import Main from './components/Main';
import ScrollToTop from './components/ScrollTop';
import LoginPage from './signup/Login';
import JoinPage from './signup/Join';
import Room from './session/Room';
import LivePage from './session/Live';
import BasicPage from './booth/Basic';
import QnaFilter from './admin/qnaFilter';
import QnaMaster from './admin/qnaMaster';
import QnaMonitor from './admin/qnaMonitor';
import ComingSoon from './components/ComingSoon';
import MyPage2 from './mypage/MyPage2';
import Satellite from './satellite/Satellite';
import Exhibition from './booth/Exhibition';
import Chat from './session/sessionComp/Chat';
import LiveChatPage from './session/LiveChat';
import MyPagePrint from './mypage/MyPagePrint';

import PosterCategory from './poster/PosterCategory';

import Poster from './poster/Poster';

import VotingPage from './admin/votingPage';
import VotingAdmin from './admin/votingAdmin';
import VotingUser from './session/sessionComp/VotingUser';

// const moment = require('moment');

export default (props) => {
  // const today = moment();
  return (
    <HashRouter>
      <ScrollToTop>
        <Switch>
          {/* {today.isAfter('2022-01-06') ? <Route exact path="/" component={LoginPage} /> : <Route exact path="/" component={ComingSoon} />} */}
          <Route exact path="/" component={LoginPage} />
          <Route exact path="/comingSoon" component={ComingSoon} />
          {/* <Route exact path='/' component={LoginPage} /> */}
          <Route exact path="/signin" component={LoginPage} />
          <Route exact path="/signup" component={JoinPage} />
          <Route exact path="/main" component={Main} />
          <Route exact path="/session" component={Room} />
          <Route exact path="/live" component={LivePage} />
          <Route exact path="/livechat" component={LiveChatPage} />
          <Route exact path="/satellite" component={Satellite} />
          <Route exact path="/mypage" component={MyPage2} />
          <Route exact path="/exhibition" component={Exhibition} />
          <Route exact path="/boothBasic/:id" component={BasicPage} />
          <Route exact path="/qnaFilter" component={QnaFilter} />
          <Route exact path="/qnaMaster" component={QnaMaster} />
          <Route exact path="/qnaMonitor" component={QnaMonitor} />
          <Route exact path="/chat" component={Chat} />
          <Route exact path="/mypage/print" component={MyPagePrint} />
          <Route exact path="/posterCategory" component={PosterCategory} />
          <Route exact path="/poster/:id" component={Poster} />
          <Route exact path="/voting" component={VotingPage} /> {/* *보팅 :: Voting 결과 확인 페이지 */}
          <Route exact path="/votingAdmin" component={VotingAdmin} /> {/* *보팅 :: Voting 문항 선택 */}
          <Route exact path="/votingUser" component={VotingUser} /> {/* *보팅 :: 사용자 화면의 Voting Tab */}
          {/* <Route exact path="/intro" component={IntroPage} /> */}
        </Switch>
      </ScrollToTop>
    </HashRouter>
  );
};
